import React, {useCallback, useEffect, useMemo, useState} from 'react';
import {useParams, useSearchParams} from 'react-router-dom';
import {get} from '../api';
import Skeleton from 'react-loading-skeleton';
import {buildRefLink} from '@goaffpro/aff-client-commons/functions';
import ShareBar from '../components/cmp/ShareBar';
import {useSelector} from 'react-redux';

function ProductLinkHistoryShare(props) {
  const website = useSelector((state)=>state.settings.website)
  const productLinkHistoryBanner = useSelector((state)=>state.settings.aff_product_link_history_banner_url || 'https://i.imgur.com/I28NkD1.jpg')
  const params = useParams();
  const [error, setError] = useState(null)
  const [links, setLinks] = useState(null)
  const [affiliate, setAffiliate] = useState(null)
  const [category, setCategory] = useState(null)
  const [categories, setCategories] = useState([])
  const [categoryItems, setCategoryItems] = useState([])
  const [loading, setLoading] = useState(false)
  const [searchParams] = useSearchParams()
  useEffect(()=>{
      setLoading(true)
    get('/favorite-links', {
      ref_code : params.ref_code
    }).then((data)=>{
      setLoading(false)
      if(data.categories){
        setCategories(data.categories)
      }
      if(data.category_links){
        setCategoryItems(data.category_links)
      }
      if(data.error){
        setError(data.error)
      }else{
        setLinks(data.links.map((i)=>{
          return {
            ...i,
            ref_link: buildRefLink(data.ref_code || params.ref_code, i.url),
          }
      }))
        setCategory(data.category)
        setAffiliate(data.affiliate)
      }
    })
  },[params.ref_code])

  const ref_link = useMemo(()=>{
    if(affiliate && affiliate.ref_code && website) {
      return buildRefLink(affiliate.ref_code, website)
    }
  },[website, affiliate])

  const filteredItems = useMemo(()=>{
    const category = searchParams.get('category');
    if(category){
      const found = categories.find((i)=>i.slug==category)
      if(found){
        const linkIds = categoryItems.filter(({category_id})=>category_id == found._id)
            .map((i)=>i.link_id)

        return links.filter(({id})=>linkIds.indexOf(id) > -1)
      }
    }
    return links;
  },[categories, categoryItems, links, searchParams])

  return (
      <div className="min-vh-100 bg-light">
        <div className="container">
        <div className={"bg-white border-bottom"} style={{borderBottomLeftRadius:'1rem', borderBottomRightRadius:'1rem'}}>
          <img src={productLinkHistoryBanner} alt=""
               className={"link-history-top-banner"}
               style={{width:'100%', maxHeight:280, objectFit:'cover'}}
          />
          <div className={"position-relative"}>
            {
              affiliate ? <>
                {
                  affiliate.profile_photo ? <img src={affiliate.profile_photo}
                            className={"link-history-avatar"}
                        /> :
                      <div style={{
                        marginTop: -80,
                        position: 'absolute',
                        borderRadius: 100,
                        width: 180,
                        height: 180,
                        marginLeft: 20,
                        border: '4px solid #fff',
                      }}>{affiliate.name.substring(0, 2)}</div>
                }</>  : null
            }
            <div className={"link-history-user"}>
              <h2>
                {
                  affiliate && affiliate.name ? <>{affiliate?.name}</>
                      : null
                }
              </h2>
              {
                ref_link ?
                    <ShareBar link={ref_link}/> : null
              }
            </div>


          </div>
        </div>
      <div className={"container border py-4 bg-white mt-4"} style={{borderRadius:'1rem'}}>
        <div className="d-flex flex-wrap">
          {
            categories.map((i)=>{
              return <CategoryItem name={i.name} slug={i.slug} key={String(i._id)} />
            })
          }
        </div>
        <div className="row">
          {
            loading ? <Skeleton height={36} count={5}/> : null
          }
        {
            filteredItems && filteredItems.filter(({image})=>image).map((i)=>{
            return <div className="col-md-4 col-lg-4 mb-2 d-flex">
                <a href={i.ref_link}
                        target={"_blank"} rel={"noreferrer noopener"}
                   className="card rounded card-link  flex-grow-1 flex-shrink-1">
                <img src={i.image}  loading={"lazy"} style={{width: '100%', height: 200}} className={"object-cover hover-contain"} alt="" />
                  <div className="card-body">
                    <div className={"text-center"}>{i.title}</div>
                  </div>
              </a>
            </div>
          })
        }
        </div>
      </div>

        </div>

      </div>
  );
}

function CategoryItem({name, slug}){
  const [searchParams,setSearchParams] = useSearchParams();
  const isActive = useMemo(()=>{
    return searchParams.get('category') === slug;
  },[searchParams])

  const onClick = useCallback(()=>{
    if(isActive){
      searchParams.delete('category')
      setSearchParams(searchParams)
    }else {
      setSearchParams({
        category: slug,
      })
    }
  },[isActive, searchParams])
  return <button onClick={onClick}
                 className={`btn rounded border mr-2 mb-2 ${isActive ? 'btn-primary' : 'btn-light'}`}>
    {name}
  </button>
}


export default ProductLinkHistoryShare;

